import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowDown,
  faArrowUp,
  faArrowUpArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import { SortDirection } from "@tanstack/react-table";

import { TYPE_ICONS } from "src/utils/constants";

export const getTypeIcon = (type: string, fallbackIcon?: IconDefinition) => {
  return TYPE_ICONS[type as keyof typeof TYPE_ICONS] ?? fallbackIcon;
};

export const getSortIcon = (
  isSorted: false | SortDirection,
  neutralIcon: IconDefinition = faArrowUpArrowDown,
): IconDefinition =>
  isSorted === "asc"
    ? faArrowUp
    : isSorted === "desc"
      ? faArrowDown
      : neutralIcon;
